<template>
    <div>
        <!-- <el-main> -->
        <div v-for="(item,index) in refundData" :key="index" class="font_card">
            <div class="row_header  el-row">
                <div class="el-col el-col-24">
                    <div class="el-col el-col-4">退款项目</div>
                    <div class="el-col el-col-4">退款补充</div>
                    <div class="el-col el-col-4">退款金额</div>
                    <div class="el-col el-col-4">退款次数</div>
                    <div class="el-col el-col-4">退款卡号</div>
                    <div class="el-col el-col-4">备注</div>
                </div>
            </div>
            <div class="el-row">
                <div class="pad_10  el-col el-col-24">
                    <div class="el-col el-col-24">
                        <!-- 1退款项目 -->
                        <div class="el-col el-col-4">
                            <span>{{item.refundProjectName}}</span>
                        </div>
                        <!-- 2退款补充 -->
                        <div class="el-col el-col-4">
                            <el-input @input="testSX" clearable v-model="item.refundReplenish" placeholder="请输入退款补充"></el-input>
                        </div>
                        <!-- 3退款金额 -->
                        <div class="el-col el-col-4">
                            <!-- {{item.refundAmt}} -->
                            <el-input disabled clearable v-model="item.refundAmt" placeholder="请输入退款金额" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                        </div>
                        <!-- 4退款次数 -->
                        <div class="el-col el-col-4">
                            <el-input-number @change="handleChange($event,index,item)" size="mini" v-model="item.refundContent" :max="item.maxNum" :min="1"></el-input-number>
                            <!-- <el-input @input="tabInput($event,index,item)" clearable v-model="item.refundContent" placeholder="请输入退款次数" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input> -->
                        </div>
                        <!-- 5退款卡号 -->
                        <div class=" el-col el-col-4" :class="item.musClass">
                            <el-input @input="testSX" oninput="value=value.replace(/[^0-9.]/g, '')" clearable v-model="item.refundCode" placeholder="请输入退款卡号" @change="cardChange($event,index)" @blur="cardBlur($event,index)"></el-input>
                            <div class="cardNum" v-if="item.flag">退款卡号不存在!</div>
                            <span style="display:none;">{{item.refundCodeTrue}}</span>
                        </div>
                        <!-- 6备注 -->
                        <div class="el-col el-col-3">
                            <el-input @input="testSX" clearable v-model="item.remark" placeholder="请输入备注"></el-input>
                        </div>
                        <!-- el-col-offset-2 -->
                        <div class=" el-col el-col-1">
                            <button type="button" class="el-button el-button--danger el-button--mini is-circle" @click.prevent="del(item,index)"><i class="el-icon-delete"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- </el-main> -->
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
    props: ['refundData', 'childData'],
    data() {
        return {
            newList1: [],
            newList2: [],
        }
    },
    computed: {
        ...mapState(['statusOptions', 'floorOptions', 'areaOptions']),
        ...mapGetters(['list1', 'list2', 'list4', 'productOptions', 'materiaOption', 'instructmentList']),
    },
    created() {
        this.newList1 = this.$store.state.list1
        this.newList2 = this.$store.state.list2
        this.newList4 = this.$store.state.list4
        this.newData = this.$store.getters.productOptions;
    },
    methods: {
        testSX() {
            this.$forceUpdate();
        },
        // 编辑时删除部位
        del(item, listIndex) {
            let newRefundData = this.refundData.map(v => {
                return { ...v, musContent: v.refundContent, musAmt: v.refundAmt }
            })
            let newList = newRefundData.concat(this.childData);
            // 筛选出当前划扣和退款的数据中存在几条当前项目
            let res2 = newList.filter(ele => ele.projectId === item.projectId)

            res2.forEach(item => {
                item.maxNum = 2000
            });

            var index = this.refundData.indexOf(item)
            if (index !== -1) {
                this.refundData.splice(listIndex, 1)
            }
        },
        // 划扣卡号查询提示
        cardBlur(e, index) {
            // musCodeTrue：划扣卡号是否存在 0、存在  1、不存在
            if (this.refundData[index].musCode && this.refundData[index].musCode != '') {
                let data = {
                    cadCode: this.refundData[index].musCode,
                    pageSize: 1
                }
                api.requestQuiet("/skn/getClientInformation", data, (res) => {
                    if (res.result == true) {
                        if (res.data.mapList.length == 0) {
                            this.refundData[index].musCodeTrue = 1
                            this.refundData[index].flag = true
                            this.refundData[index].musClass = 'musCode'
                        } else {
                            this.refundData[index].flag = false
                            this.refundData[index].musClass = ''
                            this.refundData[index].musCodeTrue = 0
                        }
                    } else {
                        this.refundData[index].musCodeTrue = 1
                        this.refundData[index].flag = true
                        this.refundData[index].musClass = 'musCode'
                        this.$forceUpdate()
                    }
                }, (err) => {
                });
            }
        },
        cardChange(e, index) {
            if (e == '' || !e) {
                this.childData[index].flag = false
                this.childData[index].musClass = ''
            }
        },
        tabInput(val, index, row) {
            row.refundAmt = ''
            // console.log(val);
            if (val && val == 0) {
                row.refundContent = 1
                row.musContent = 1
            } else if (val != 0) {
                row.musContent = Number(val)
                row.refundContent = Number(val)
                this.getVal(this.refundData, this.childData, row, val)
            }
        },
        handleChange(val, index, row) {
            console.log(row);
            row.maxNum = 2000
            this.getVal(this.refundData, this.childData, row, val)
            this.$forceUpdate()
        },
        getVal(refundData, childData, row, val) {
            row.refundAmt = ''
            let newRefundData = refundData.map(v => {
                return { ...v, musContent: v.refundContent, musAmt: v.refundAmt }
            })
            // console.log(newRefundData);
            let newList = newRefundData.concat(childData);
            // 筛选出当前划扣和退款的数据中存在几条当前项目
            let res2 = newList.filter(ele => ele.projectId === row.projectId)
            let res = res2.reduce((sumData, key, index, arrData) => {
                return sumData + key.musContent
            }, 0)
            let res3 = res2.reduce((sumData, key, index, arrData) => {
                return sumData + Number(key.musAmt)
            }, 0)
            // console.log(res);
            console.log(Number(res), Number(row.residueNumber));
            if (Number(res) > Number(row.residueNumber)) {
                row.refundAmt = (Number(row.projectAmt) - Number(row.amt) - res3).toFixed(2)
                row.maxNum = Number(row.residueNumber) - (res - val)
                _g.toast("warning", '有效次数不足！！！');
                return;
            } else if (Number(res) == Number(row.residueNumber)) {
                row.maxNum = Number(row.residueNumber) - (res - val)
                row.refundAmt = (Number(row.projectAmt) - Number(row.amt) - res3).toFixed(2)
                // console.log(row.refundAmt);
            } else if (Number(res) < Number(row.residueNumber)) {
                // row.musContent = row.refundContent
                row.refundAmt = (row.unitPrice * row.refundContent).toFixed(2)
            }
        },
    }
}
</script>
<style scoped>
.font_card {
  border: 1px solid #eee;
  margin-bottom: 6px;
  /* background: #e0e6f0; */
  border-radius: 10px;
}
.row_header {
  background-color: #c2e0f1;
  padding: 10px;
  border-radius: 10px;
}
.main_font {
  font-size: 13px !important;
  font-weight: 500;
  /* border: 1px solid blue; */
}
.el-row {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.font_header {
  background-color: #fff7f3;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
}
.doc_header {
  background-color: #dbf0b9;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
}
.pad_10 {
  padding: 4px;
  box-sizing: border-box;
  line-height: 35px;
}
.cardNum {
  color: #f56c6c;
  font-size: 12px;
}
.musCode >>> .el-input__inner {
  border-color: #f56c6c;
}
</style>


